export default __webpack_public_path__ + "static/media/1.89872b85.png";